module.exports = __webpack_public_path__ + "img/vertical_7_6_2.a909acde.png";